import { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const ContentWrapper = styled.div`
  flex: 0 0 40em;
  margin-top: 130px;
`;

export const VersionWrapper = styled.div`
  margin-bottom: -10px;
  letter-spacing: 3px;
  font-size: 25px;
  font-weight: 700;
`;

export const VersionDecoration = styled.div`
  width: 170px;
  height: 15px;
  background-color: ${({ theme }) => theme.colors?.header};
`;

export const VersionTitle = styled.div`
  margin-top: 40px;
  color: ${({ theme }) => theme.colors?.header};
`;

export const Title = styled.div`
  font-size: 70px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.text.tertiary};
  letter-spacing: -2.8px;
  margin-bottom: 5px;
`;

export const SubTitle = styled.div`
  font-size: 23px;
  text-align: justify;
  margin-bottom: 25px;
  position: relative;

  span {
    font-weight: 600;
  }
`;

export const buttonStyle: CSSProperties = {
  fontSize: 25,
  fontWeight: 400,
  borderRadius: 15,
};

export const ButtonWrapper = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 85px;
  margin-top: 75px;
  font-size: 25px;
  font-weight: 400;
`;
